import { gql } from '@apollo/client'
import { PHYSICAL_STORE_FRAGMENT } from '../fragments'

export const GET_PHYSICAL_STORE = gql`
  query GetPhysicalStore($storeId: ID!) {
    physicalStore(storeId: $storeId) {
      ...PhysicalStore
    }
  }
  ${PHYSICAL_STORE_FRAGMENT}
`
